<template>
    <system-page :page-settings="page">
        <div class="c-content main">
            <div class="c-warningBox c-warningBox-icon u-mb-lg">
                <p>この端末では既に複数のアカウントをご利用中です。</p>
                <p>不正利用防止ため、1台の端末でのご利用アカウント数には制限がございます。</p>
                <p>恐れ入りますが、他の端末をご利用いただくか、現在使用中のアカウントでのログインをお願いいたします。</p>
            </div>

            <router-link
                :to="{name: 'Login'}"
                class="c-btn c-btn-primary"
            >
                再ログインはこちら
            </router-link>
        </div>
    </system-page>
</template>

<script>
import SystemPage from '@/component/SystemPage.vue'

export default {
    name: 'AccountLock',
    components: {
        SystemPage,
    },
    data() {
        return {
            page: {
                title: 'ご利用端末での利用可能なアカウント数が上限に達しました。',
                breakedTitle: 'ご利用端末での<br class="u-display-sp">利用可能なアカウント数が上限に達しました。',
                desc: 'ポケモンカードゲーム プレイヤーズクラブ ご利用端末での利用可能なアカウント数が上限に達しましたのページ。',
                breadcrumb: [],
            },
        }
    },
    mounted() {
        document.title = this.page.title + ' | ポケモンカードゲーム プレイヤーズクラブ'
        document.querySelector("meta[name='description']").setAttribute('content', this.page.desc)
    },
}
</script>

<style lang="scss" scoped>
@use '~@/assets/style/global' as g;

.main {
    text-align: center;
    @include g.pc {
        padding-top: 65px;
        padding-bottom: 110px;
    }
    @include g.sp {
        padding-top: 18px;
        padding-bottom: 72px;
    }
}

.c-warningBox {
    position: relative;
    text-align: left;

    &::before {
        position: absolute;
        left: 32px;
    }

    & > p {
        margin-left: 21px;
        font-weight: bold;
    }
}

</style>
